export default __webpack_public_path__ + "static/habilidades2-1fd6b8ec3e15711661ae6de6cead815b.jpeg";